/* eslint-disable */
// @ts-nocheck

import { NavLink, useLocation } from "react-router-dom";
import React, { useContext } from "react";
import { checkProfiles } from "config/functions";
import { AuthContext } from "contexts/requiredAuth";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  HStack,
  Text,
  List,
  Icon,
  ListItem,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaCircle } from "react-icons/fa";

export function SidebarLinks(props: {
  routes: RoutesType[];
  [x: string]: any;
}) {
  const location = useLocation();
  const activeColor = useColorModeValue("gray.700", "white");
  const inactiveColor = useColorModeValue(
    "secondaryGray.600",
    "secondaryGray.600"
  );
  const activeIcon = useColorModeValue("brand.500", "white");

  const { routes } = props;
  const { user } = useContext(AuthContext);
  const perfis = user.perfis;

  // Verifica se a rota está ativa
  const activeRoute = (routeName: string) =>
    location.pathname.includes(routeName);

  // Cria os links e accordions do menu lateral
  const createLinks = (routes: RoutesType[]) => {
    return routes.map((route, key) => {
      const allowed = checkProfiles(route.allowedProfiles, perfis);

      if (!allowed) return null;

      if (route.collapse) {
        return (
          <Accordion allowMultiple key={key} index={0}>
            <AccordionItem border="none">
              <AccordionButton
                display="flex"
                alignItems="center"
                justifyContent="center"
                _hover={{ bg: "unset" }}
                _focus={{ boxShadow: "none" }}
                borderRadius="8px"
                w={{ sm: "100%", xl: "100%", "2xl": "95%" }}
                px={route.icon ? null : "0px"}
                py="0px"
                bg="transparent"
                ms={0}
              >
                {route.icon ? (
                  <Flex align="center" justifyContent="space-between" w="100%">
                    <HStack
                      mb="6px"
                      spacing={
                        activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                      }
                    >
                      <Flex
                        w="100%"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Box
                          color={
                            activeRoute(route.path.toLowerCase())
                              ? activeIcon
                              : inactiveColor
                          }
                          me="12px"
                          mt="6px"
                        >
                          {route.icon}
                        </Box>
                        <Text
                          me="auto"
                          color={
                            activeRoute(route.path.toLowerCase())
                              ? activeColor
                              : inactiveColor
                          }
                          fontWeight="500"
                          fontSize="md"
                        >
                          {route.name}
                        </Text>
                      </Flex>
                    </HStack>
                    <AccordionIcon ms="auto" color="secondaryGray.600" />
                  </Flex>
                ) : (
                  <Flex pt="0px" pb="10px" alignItems="center" w="100%">
                    <HStack
                      spacing={
                        activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                      }
                      ps="34px"
                    >
                      <Text
                        me="auto"
                        color={
                          activeRoute(route.path.toLowerCase())
                            ? activeColor
                            : inactiveColor
                        }
                        fontWeight="500"
                        fontSize="sm"
                      >
                        {route.name}
                      </Text>
                    </HStack>
                    <AccordionIcon ms="auto" color="secondaryGray.600" />
                  </Flex>
                )}
              </AccordionButton>

              <AccordionPanel
                pe={route.icon ? null : "0px"}
                py="0px"
                ps={route.icon ? null : "8px"}
              >
                <List>
                  {route.icon
                    ? createLinks(route.items) // com ícone
                    : createAccordionLinks(route.items)}{" "}
                  // sem ícone
                </List>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        );
      } else {
        return (
          <NavLink to={route.layout + route.path} key={key}>
            {route.icon ? (
              <Flex
                align="center"
                justifyContent="space-between"
                w="100%"
                ps="17px"
                mb="0px"
              >
                <HStack
                  mb="6px"
                  spacing={
                    activeRoute(route.path.toLowerCase()) ? "22px" : "26px"
                  }
                >
                  <Flex w="100%" alignItems="center" justifyContent="center">
                    <Box
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeIcon
                          : inactiveColor
                      }
                      me="12px"
                      mt="6px"
                    >
                      {route.icon}
                    </Box>
                    <Text
                      me="auto"
                      color={
                        activeRoute(route.path.toLowerCase())
                          ? activeColor
                          : inactiveColor
                      }
                      fontWeight="500"
                    >
                      {route.name}
                    </Text>
                  </Flex>
                </HStack>
              </Flex>
            ) : (
              <ListItem ms={null}>
                <Flex ps="34px" alignItems="center" mb="8px">
                  <Text
                    color={
                      activeRoute(route.path.toLowerCase())
                        ? activeColor
                        : inactiveColor
                    }
                    fontWeight="500"
                    fontSize="sm"
                  >
                    {route.name}
                  </Text>
                </Flex>
              </ListItem>
            )}
          </NavLink>
        );
      }
    });
  };

  // Cria os links dentro dos accordions secundários
  const createAccordionLinks = (routes: RoutesType[]) => {
    return routes.map((route: RoutesType, key: number) => (
      <NavLink to={route.layout + route.path} key={key}>
        <ListItem ms="28px" display="flex" alignItems="center" mb="10px">
          <Icon w="6px" h="6px" me="8px" as={FaCircle} color={activeIcon} />
          <Text
            color={
              activeRoute(route.path.toLowerCase())
                ? activeColor
                : inactiveColor
            }
            fontWeight={
              activeRoute(route.path.toLowerCase()) ? "bold" : "normal"
            }
            fontSize="sm"
          >
            {route.name}
          </Text>
        </ListItem>
      </NavLink>
    ));
  };

  // Renderiza os links do sidebar
  return <>{createLinks(routes)}</>;
}

export default SidebarLinks;
